const reportManagementRouter = [
  {
      path: "list-car_for_sell",
      name: "list",
      component: () => import("@/views/admin/car_for_sell"),
      default: true,
      meta: {
          model: "car_for_sell",
          // requiresAuth: true,
      },
  },
  {
      path: "list-car_for_sell/add",
      name: "add",
      component: () => import("@/views/admin/car_for_sell/function"),
      default: true,
      meta: {
          model: "car_for_sell",
          // requiresAuth: true,
      },
  },
  {
      path: "list-car_for_sell/edit/:id",
      name: "edit",
      component: () => import("@/views/admin/car_for_sell/function"),
      default: true,
      meta: {
          model: "car_for_sell",
          // requiresAuth: true,
      },
  },
];
export default reportManagementRouter;